<template lang="pug">
#relatorio-filtros
    .filtros
        .pesquisa-filtros__container
            .pesquisa-filtros__barra-pesquisa
                i.el-icon-search
                input(
                    v-model='searchTerm',
                    type='text',
                    :placeholder='$t("relatorioExportacao.lista.filtroPlaceholder")',
                    autocomplete='off',
                    @keyup.enter='aplicarFiltros'
                )
                i.el-icon-circle-close(
                    v-if='searchTerm',
                    @click='limparFiltros'
                )

        .filtros-data
            el-date-picker.input-data-cadastro(
                v-model='dataSelecionada',
                type='daterange',
                range-separator='-',
                clearable,
                editable,
                format='dd/MM/yyyy',
                :start-placeholder='$t("relatorioExportacao.lista.dataInicio")',
                :end-placeholder='$t("relatorioExportacao.lista.dataFim")',
                size='large',
                @change='aplicarFiltros'
            )
</template>

<script>
export default {
    name: 'RelatorioFiltros',
    data() {
        return {
            collapse: null,
            dataSelecionada: '',
            searchTerm: ''
        };
    },
    methods: {

        aplicarFiltros() {
            const dataSelecionada = this.dataSelecionada || '';
            const dataInicio = dataSelecionada
                ? this.converterData(dataSelecionada[0])
                : '';
            const dataFim = dataSelecionada
                ? this.converterData(dataSelecionada[1])
                : '';
            const searchTerm = this.searchTerm || '';

            const filtro = {
                dataInicio,
                dataFim,
                searchTerm
            };
            this.$emit('emitFiltros', filtro);
        },
        converterData(value) {
            const date = new Date(value);
            const dia = String(date.getDate()).padStart(2, '0');
            const mes = String(date.getMonth() + 1).padStart(2, '0');
            const ano = date.getFullYear();
            
            return `${dia}/${mes}/${ano}`;
        },
        limparFiltros() {
            this.tags = [];
            this.dataSelecionada = '';
            this.searchTerm = '';
            this.aplicarFiltros();
        },

        removerFiltro(filtro) {
            this.tags.splice(this.tags.indexOf(filtro), 1);
            this.desmarcarFiltroPopover(filtro);
            this.aplicarFiltros();
        },

        desmarcarFiltroPopover(filtro) {
            if (filtro === 'Data do denuncia') {
                this.dataSelecionada = '';
            }
        }
    }
};
</script>

<style lang="scss">
#relatorio-filtros {
    body {
        overflow-y: hidden;
        overflow-x: hidden;
    }
    
    .filtros {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        gap: 10px;
    }
    
    .pesquisa-filtros__container {
        width: 100%;
        height: 42px;
        border-radius: 5px;
        background: var(--white);
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        position: relative;
    }
    
    .filtros-data {
        box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);
    }
    
    .input-data-cadastro {
        height: 43px !important;
    
        .el-input__inner {
            height: 43px !important;
        }
    }
    
    .pesquisa-filtros__barra-pesquisa {
        height: 100%;
        display: flex;
        justify-content: center;
    
        i.el-icon-search {
            color: var(--gray);
            font-size: 16px;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }

        i.el-icon-circle-close {
            color: var(--gray);
            font-size: 16px;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }
    
        input {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            border-radius: 5px;
            color: var(--primary);
        }
    }

}
</style>
